import React, { useEffect } from 'react';
import Logo from "../../elements/logo/Logo";
import Nav from './Nav';
import { FiX } from "react-icons/fi";

const MobileMenu = ({show, onClose}) => {

    useEffect(() => {
        if (!show) return; // Don't run when menu is closed

        const elements = document.querySelectorAll('.popup-mobile-menu .has-droupdown > a');
        const elementsTwo = document.querySelectorAll('.popup-mobile-menu .with-megamenu > a');

        for (let i = 0; i < elements.length; i++) {
            elements[i].onclick = function() {
                const submenu = this.parentElement.querySelector('.submenu');
                if (submenu) submenu.classList.toggle("active");
                this.classList.toggle("open");
            }
        }

        for (let i = 0; i < elementsTwo.length; i++) {
            elementsTwo[i].onclick = function() {
                const megamenu = this.parentElement.querySelector('.rn-megamenu');
                if (megamenu) megamenu.classList.toggle("active");
                this.classList.toggle("open");
            }
        }

    }, [show]); // Run only when menu opens

    return (
        <div className={`popup-mobile-menu ${show ? "active": ""}`}>
            <div className="inner">
                <div className="header-top">
                    <Logo />
                    <div className="close-menu">
                        <span className="close-button" onClick={onClose}><FiX /></span>
                    </div>
                </div>
                <Nav />
            </div>
        </div>
    )
}

export default MobileMenu;